import React, { useState, useEffect } from 'react';
import { CustomTable, Loader, Pagination, Search } from '@ohif/ui';
import Header from '../../Header/Header';
import { useSelector, useDispatch } from 'react-redux';
import fetchRollbackList from '@custom/rtk-apis/report/RollbackList';
import { AppDispatch, RootState } from '@custom/store/store';
import LoaderWrapper from '@custom/Loader/loaderWrapper';
import { calculateAge, customStyle, formatDate, formatTime } from '@custom/Utils/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from "../../../ui/src/contextProviders"

const RollbackList = () => {

  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const dispatch = useDispatch<AppDispatch>();
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalPg, setTotalPg] = useState(0);

  // Fetching rollback data from Redux state
  const { data, loading, error, total } = useSelector((state: RootState) => state.RollbackListresponce);
  ;

  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [searchInputValue, setSearchInputValue] = useState('');

  // Fetch data on component mount
  useEffect(() => {
    dispatch(fetchRollbackList({ limit: pgLimit, pageNumber: pgNumber, search: searchInputValue }));
  }, []);

  // Update tableData and filteredData when data or status changes
  useEffect(() => {
    if (data && data.length > 0) {
      setTotalPg(total)
      let tempArray = data.map((item) => ({
        mainReport: item?.mainReport || "--",
        _id: item._id || '--',
        name: item?.name
          ? item.name
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
          : '--',
        reportName: item?.reportName
          ? item.reportName
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
          : '--',
        modality: item?.modality || '--',
        studyRegion: item?.studyRegion || "--",
        age: calculateAge(item?.age) || "--",
        gender: item?.gender || "--",
        date: formatDate(item?.date) || "--",
        time: formatTime(`${item.date}T${item?.time}`) || "--",
        patientId: item?.patientId || "--",
        uhid: item?.uhid || "--",
        rollbackReason: item?.rollbackReason || "--",
        rollbackDoneBy: item?.rollbackDoneBy
          ? item.rollbackDoneBy
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
          : '--',
      }));
      setTableData(tempArray);
      setFilteredData(tempArray);
    }
  }, [data]);

  // Pagination and search states

  const [search, setSearch] = useState('');

  const columns = [
    { key: 'name', title: 'Name', sort: true },
    { key: 'reportName', title: 'Report Name', sort: true },
    { key: 'gender', title: 'Gender' },
    { key: 'modality', title: 'Modality', sort: true },
    { key: "studyRegion", title: "Study Region", sort: true },
    { key: 'age', title: 'Age' },
    { key: 'date', title: 'Date', sort: true },
    { key: 'time', title: 'Time' },
    { key: 'patientId', title: 'Patient ID' },
    { key: 'uhid', title: 'UHID' },
    { key: 'rollbackReason', title: 'Rollback Reason' },
    { key: 'rollbackDoneBy', title: 'Radiologist Name' },
    { key: 'actions', title: 'Action' }
  ];

  const actions = [
    {
      label: 'Rollback Report',
      iconName: isDarkMode ? 'darkModeRollbackReportIcon' : 'rollbackReportIcon',
      onClick: (item: any) => {
        if (item._id) {
          navigate(`/rollbackpreview/${item._id}`);
        } else {
          console.error("Item _id is missing, cannot navigate.");
        }
      }
    },
    {
      label: 'Preview',
      iconName: isDarkMode ? 'darkModePreviewReport' : 'previewReport',
      onClick: (item: any) => {
        if (item._id) {
          navigate(`/report/preview/${item.mainReport}`, {state: { from: '/rollbacklist'} });
        } else {
          console.error("Item _id is missing, cannot navigate.");
        }
      }
    }
  ];


  const handlePageSizeChange = (size: number) => {
    setPgLimit(size);
    dispatch(fetchRollbackList({ limit: pgLimit, pageNumber: pgNumber, search: searchInputValue }));
  };

  const onPageChangeHandler = (page: number) => {
    setPgNumber(page);
    dispatch(fetchRollbackList({ limit: pgLimit, pageNumber: page, search: searchInputValue }));
  };

  const handleSearchClick = (searchText: string) => {
   setSearch(searchText);
    setSearchInputValue(searchText);
    setPgNumber(1);
    dispatch(fetchRollbackList({ limit: pgLimit, pageNumber: pgNumber, search: searchText }));
  };

  return (
    <>
      <div className='page page__fullBody' style={
        isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header title="Rollback Report" />
        <div className='page__body'>
          <div className='tableWrap'>
            <div className='tableWrap__head'>
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className='formCol'>
                  <Search
                    text="Name, Report Name, Patient ID, UHID"
                    onSearchClick={handleSearchClick}
                    value={searchInputValue}
                    setValue={setSearchInputValue}
                  />
                </div>
              </div>
            </div>
            <div className='tableContainer'>
              <CustomTable
                columns={columns}
                data={filteredData || []}
                actions={actions}
                searchQuery={search}
                from="rollback"
              />
            </div>
          </div>
        </div>
        <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPg}
          currentPage={pgNumber}
          perPage={pgLimit}
        />
        <Loader isLoaderOpen={loading}></Loader>
      </div>
    </>
  );
};

export default RollbackList;
